<template>
  <form
    class="main-modal main-modal_w600 main-modal_materials"
    @submit.prevent="save"
    v-if="mutatedMaterials"
  >
    <div class="main-modal__title">
      <p>{{$t("materials.updateMaterial")}}</p>
    </div>

    <div class="main-form__box main-form__box_relative">
      <label class="main-form__label">Materialien</label>
      <multiselect
        v-model="editableMaterials"
        :options="mutatedMaterials"
        :multiple="true"
        label="text"
        track-by="id"
        :placeholder="'Materialien'"
      />
    </div>

    <div class="main-form__box" v-if="editableMaterials.length > 0">
      <div
        class="main-layout__item"
        v-for="(item, index) in editableMaterials"
        :key="item.material_id"
      >
        <p class="w-3">{{ index + 1 }}.</p>
        <p class="w-18">{{ item.text }}</p>
        <p class="w-10">€ {{ round(item.price) }}</p>
        <p class="w-20">
          <input
            style="text-align: center;
            width: 80px;background-color: transparent !important;
            color: var(--menu-text-color);border: 1px solid var(--border-color);
            border-radius: 4px;outline:none"
            type="number"
            v-model="item.qty"
            min="1"
            max="999"
          />
        </p>
        <p class="mr16">€ {{ round(item.price * item.qty) }}</p>

        <span @click="removeMaterial(item.material_id)">
          <svg
            width="14"
            height="14"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="c-p"
          >
            // eslint-disable-line
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M16.9703 5.70725C17.3612 5.31725 17.3612 4.68325 16.9703 4.29325C16.5802 3.90225 15.9472 3.90225 15.5562 4.29325L10.6322 9.21725L5.70725 4.29325C5.31725 3.90225 4.68325 3.90225 4.29325 4.29325C3.90225 4.68325 3.90225 5.31725 4.29325 5.70725L9.21725 10.6322L4.29325 15.5562C3.90225 15.9472 3.90225 16.5802 4.29325 16.9703C4.68325 17.3612 5.31725 17.3612 5.70725 16.9703L10.6322 12.0463L15.5562 16.9703C15.9472 17.3612 16.5802 17.3612 16.9703 16.9703C17.3612 16.5802 17.3612 15.9472 16.9703 15.5562L12.0463 10.6322L16.9703 5.70725Z"
              fill="var(--menu-text-color)"
            />
          </svg>
        </span>
      </div>
    </div>

    <div class="main-form__box main-form__box_flex mt16">
      <button class="main-button" type="submit" style="border-radius:4px !important">Save</button>
    </div>
  </form>
</template>

<script>
import { mapMutations, mapActions } from 'vuex'

export default {
    props: {
        materials: {
            required: true,
        },
        serviceId: {
            required: true,
        },
    },
    data() {
        return {
            mutatedMaterials: null,
            editableMaterials: null,
        }
    },
    methods: {
        ...mapActions({
            fetchMaterials: 'materials/fetch',
        }),
        ...mapMutations({
            clearMaterials: 'materials/clear',
        }),
        removeMaterial(id) {
            this.editableMaterials = this.editableMaterials.filter(
                (item) => item.material_id !== id,
            )
        },
        save() {
            this.$emit('done', this.editableMaterials)
        },
        getMaterials() {
            this.clearMaterials()
            this.fetchMaterials({ id: this.serviceId, page: 'materials' }).then(
                (res) => {
                    this.mutatedMaterials = res.data.map((material) => ({
                        price: material.price,
                        text: `${material.name.original} €${material.price}`,
                        qty: 1,
                        material_id: material.id,
                        icon: material.icon.path,
                        id: material.id,
                    }))
                },
            )
        },
        round(num) {
            return Math.round(num)
        },
    },
    created() {
        this.editableMaterials = [...this.materials]
        this.getMaterials()
    },
}
</script>

<style>
.main-modal_materials .multiselect__content-wrapper {
  width: 100% !important;
  max-width: 100% !important;
}
</style>
